module.exports = __webpack_public_path__ + "img/visa.073aa163.svg";